
<template>
    <div id="vendorInvoicePreview">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <template v-if="dataFound === true">
            <div class="form-row">    
                <div class="col-sm-12 mb-4">
                    <!--Previous Next Button-->
                    <button type="button" v-if="previous_voucher != ''" class="btn btn-secondary" id="previousBtn"  v-on:click.prevent="loadInvoicePreview('previous')">Previous</button>
                    <button type="button" v-if="next_voucher != ''" class="btn btn-secondary" id="nextBtn"  v-on:click.prevent="loadInvoicePreview('next')">Next</button>
                    <div class="pull-right">
                    <template v-if="selectedStatus == 'entered' && ( canVerify || canApprove || canApproveSubletInv )">
                        <button type="button" class="btn btn-primary" id="verifyStatusBtnPreview" v-on:click="confirmStatus('verified')">Verify</button>
                    </template>
                    <template v-else-if="selectedStatus == 'verified' && (canApprove || canApproveSubletInv)">
                        <!-- <template v-if="!isVerifiedBy"> -->
                            <button v-if="invType == 'sublet_invoice' && (canApprove || canApproveSubletInv)" type="button" class="btn btn-secondary" id="approveStatusBtnPreview" v-on:click="confirmStatus('approved')">Approve</button>
                            <button v-else-if="canApprove" type="button" class="btn btn-secondary" id="approveStatusBtnPreview" v-on:click="confirmStatus('approved')">Approve</button>
                        <!-- </template>
                        <template v-else>
                            <p class="field-error pull-left">You can only approve those invoice which are verified by other.&nbsp;&nbsp;</p>
                        </template>-->
                        <button type="button" class="btn btn-primary" id="unverifyStatusBtnPreview" v-on:click="confirmStatus('entered')">Unverify</button>
                    </template>
                    <template v-else-if="selectedStatus == 'disapproved' && (canApprove || canApproveSubletInv)">
                        <!-- <template v-if="!isVerifiedBy"> -->
                            <button v-if="invType == 'sublet_invoice'" type="button" class="btn btn-secondary" id="approveStatusBtnPreview"  v-on:click="confirmStatus('approved')">Approve</button>
                            <button v-else-if="canApprove" type="button" class="btn btn-secondary" id="approveStatusBtnPreview"  v-on:click="confirmStatus('approved')">Approve</button>
                            <button type="button" class="btn btn-secondary" id="voidStatusBtnPreview"  v-on:click="confirmStatus('void')">Void</button>
                        <!-- </template>
                        <template v-else>
                            <p class="field-error">You can only approve those invoice which are verified by other.</p>
                        </template> -->
                    </template>
                    <template v-else-if="selectedStatus == 'approved' && (canApprove || canApproveSubletInv)">
                        <button v-if="invType == 'sublet_invoice'" type="button" class="btn btn-secondary" id="disapproveStatusBtnPreview" v-on:click="confirmStatus('disapproved')">Disapprove</button>
                        <button v-else-if="canApprove" type="button" class="btn btn-secondary" id="disapproveStatusBtnPreview" v-on:click="confirmStatus('disapproved')">Disapprove</button>
                    </template>    
                    <!-- <button type="button" class="btn btn-secondary" id="approveStatusBtnPreview"  v-on:click="closeInvoicePreview()"><i class="fp-back"></i>Back</button> -->
                    </div>
                </div>
                <template v-if="workOrderGLArr && workOrderGLArr.length > 0">
                    <div class="col-sm-12 loader-position" v-if="canViewGL">
                        <div class="journal-title">
                            <h5> {{woGlTitle}} </h5>
                        </div>
                        <div :id="'wo_gl_preview'" class="accordian-body collapse show">
                            <div class="table-reponsive-sm">
                                <table aria-describedby="table" id="contact_table" class="table table-bordered table-sm purchase-order-item-table font-1" >
                                    <thead>
                                        <tr class="table-primary">
                                            <th>Account</th>
                                            <th class="text-right">Debit</th>
                                            <th class="text-right">Credit</th>
                                            <th class="text-right">Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="workOrderGLArr != undefined && workOrderGLArr.length > 0">
                                        <template v-for="(woItem , woKey) in workOrderGLArr">
                                            <tr :key="'wo_gl_item'+woKey">
                                                <template v-if="woItem.account_description == 'Total'">
                                                    <td class="text-right">{{woItem.account_description}}</td>
                                                </template>
                                                <template v-else>
                                                    <td>{{woItem.account_description}}</td>
                                                </template>
                                                <td class="text-right">{{woItem.debit}}</td>
                                                <td class="text-right">{{woItem.credit}}</td>
                                                <td class="text-right">{{woItem.journal_amount}}</td>
                                            </tr>
                                        </template>
                                    </tbody>
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="4"><h5>No GL Found</h5></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>    
                        </div>
                    </div>
                </template>
                <!-- General Ledger -->
                <template v-if="canViewGL">
                    <div class="col-sm-12 loader-position">
                        <div :class="`loader-div${loaderClass}`" v-show="loadingGL"></div>
                        <div class="journal-title">
                            <h5> {{glTitle}} </h5>
                        </div>
                        <div class="table-reponsive-sm mb-4">    
                            <table aria-describedby="table" id="contact_table" class="table table-bordered table-sm purchase-order-item-table font-1" >
                                <thead>
                                    <tr class="table-primary">
                                        <th>Account</th>
                                        <th class="text-right">Debit</th>
                                        <th class="text-right">Credit</th>
                                        <th class="text-right">Amount</th>                                                                                                        
                                    </tr>
                                </thead>
                                <tbody v-if="glArr != undefined && glArr.length > 0">
                                    <template v-for="(journalItem , journalKey) in glArr">
                                        <tr :key="'journal'+journalKey">
                                            <template v-if="journalItem.account_description == 'Total'">
                                                <td class="text-right">{{journalItem.account_description}}</td>
                                            </template>
                                            <template v-else>
                                                <td>{{journalItem.account_description}}</td>
                                            </template>
                                            <td class="text-right">{{journalItem.debit}}</td>
                                            <td class="text-right">{{journalItem.credit}}</td>
                                            <td class="text-right">{{journalItem.journal_amount}}</td>                                                                                
                                        </tr>                                                    
                                    </template>    
                                </tbody>
                                <tbody v-else>
                                    <tr>
                                        <td colspan="4"><h5>No GL Found</h5></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </template>    
            </div>
            <!-- Vendor Invoice Details-->
            <div class="form-row">
                <div class="col-sm-12">
                    <div class="journal-title">
                        <h5> Vendor Invoice Details </h5>
                    </div>
                    <div class="table-reponsive-sm mb-4">
                        <table aria-describedby="table" id="contact_table" class="table table-sm purchase-order-item-table font-1" >
                            <tr>
                                <td class="border-none wt-20">
                                    <label>#Invoice :</label>
                                </td>
                                <td class="border-none wt-30">
                                    <span> {{ invoice_number }} </span>
                                </td>
                                <td class="border-none wt-20">
                                    <label>#Voucher :</label>
                                </td>
                                <td class="border-none wt-30">
                                    <span> {{ voucherNumber }} </span>
                                </td>                                                                                                      
                            </tr>
                            <tr>
                                <td class="border-none wt-20">
                                    <label>#Vendor PO :</label>
                                </td>
                                <td class="border-none wt-30">
                                    <span> {{ vendor_po }} </span>
                                </td>
                                <td class="border-none wt-20">
                                    <label>Vendor :</label>
                                </td>
                                <td class="border-none wt-30">
                                    <span> {{ vendor }} </span>
                                </td>                                                                                                  
                            </tr>
                            <tr>
                                <td class="border-none wt-20">
                                    <label>Status :</label>
                                </td>
                                <td class="border-none wt-30">
                                    <span> {{ status }} </span>
                                </td>
                                <td class="border-none wt-20">
                                    <label>Amount :</label>
                                </td>
                                <td class="border-none wt-30">
                                    <span> {{ amount }} </span>
                                </td>                                                                                                  
                            </tr>
                            <tr>
                                <td class="border-none wt-20">
                                    <label>Invoice Date :</label>
                                </td>
                                <td class="border-none wt-30">
                                    <span> {{ invoice_date }} </span>
                                </td>
                                <td class="border-none wt-20">
                                    <label>Due Date :</label>
                                </td>
                                <td class="border-none wt-30">
                                    <span> {{ due_date }} </span>
                                </td>                                                                                                  
                            </tr>
                            <tr>
                                <td class="border-none wt-20">
                                    <label>Verified By :</label>
                                </td>
                                <td class="border-none wt-30">
                                    <span> {{ verified_by }} </span>
                                </td>
                                <td class="border-none wt-20">
                                    <label>Approved By :</label>
                                </td>
                                <td class="border-none wt-30">
                                    <span> {{ approved_by }} </span>
                                </td>                                                                                                  
                            </tr>
                            <tr>
                                <td class="border-none wt-20">
                                    <label>Monthly Payable :</label>
                                </td>
                                <td class="border-none wt-30">
                                    <span> {{ monthly_payable }} </span>
                                </td>
                                <td class="border-none wt-20">
                                    &nbsp;
                                </td>
                                <td class="border-none wt-30">
                                    &nbsp;
                                </td>                                                                                                  
                            </tr>
                        </table>
                    </div>
                </div>
            </div>        
            <template v-if="fileFound === true">
                <template v-if="extension == 'pdf'">
                    <iframe :src="path" title="" width="100%" height="500px" id="invoicePreview"></iframe>
                </template>
                <template v-else>
                    <img :src="path" id="invoicePreview" width="100%" alt="Vendor Invoice Preview"/>
                </template>
            </template>
            <template v-else-if="fileFound === false">
                <div class="message-not-found">
                    <h4>File Not Found.</h4>
                </div>
            </template>    
        </template>
        <template v-else-if="dataFound == ''">
            <div class="message-not-found">
                <h4>Fetching data.....</h4>
            </div>
        </template>          
        <template v-else-if="dataFound === false">
            <div class="message-not-found">
                <h4>No Record Found.</h4>
            </div>
        </template>      
    </div>
</template>
                    
<script>
import Vue from 'vue';

import EventBus from "../event-bus";

import {commonMixins} from '../../mixins/commonMixins';


export default {
    name: "VendorInvoicePreview",
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Vendor Invoice Preview  | " +process.env.COPYRIGHT_NAME
    },
    
    mixins:[commonMixins],
    props: {
        moduleName: {
            type: String,
            required: false,
            default:undefined
        },
        vendorInvoiceId: {
            type: Number,
            required: true,
            default:undefined
        },
        permissions: {
            type: Array,
            required: true,
            default:undefined
        },
    },
    data: () => ({
        loading:false,
        //permissions:[],
        cantAccessPage:"",
        //vendorInvoiceId:0,
        voucherNumber:'',
        voucher_number_error_msg:"",
        flag:"load",
        dataFound:"",
        fileFound:"",
        extension:"",
        path:"",
        canVerify:false,
        canApprove:false,
        isVerifiedBy:false,
        loggedInUser:0,
        selectedStatus:"",
        glArr:[],
        canViewGL:false,
        invoice_number:"",
        vendor_id:0,
        vendor:"",
        vendor_po:"",
        status:"",
        amount:"",
        invoice_date:"",
        due_date:"",
        verified_by:"",
        approved_by:"",
        monthly_payable:"",
        previous_voucher:"",
        next_voucher:"",
        loadingGL:false,
        workOrderGLArr:[],
        glTitle:"General Ledger",
        woGlTitle:"Work Order GL Preview",
        canApproveSubletInv:false,
        invType:""
    }),
    watch:{

        permissions: function(permission) {
            
            var self = this;
            // permission.forEach(function (permissions) {
                
            //     if ( permissions.name == 'view_vendor_invoice' ) {
            //         self.cantAccessPage = true;
            //     } else if (permissions.name == 'can_verify_vendor_invoice') {
            //         self.canVerify = true;
            //     } else if (permissions.name == 'can_approve_vendor_invoice') {
            //         self.canApprove = true;
            //     }else if (permissions.name == 'view_general_ledger') {
            //         self.canViewGL = true; 
            //     } else if ( permissions.name == 'can_approve_sublet_invoice' ) {
            //         self.canApproveSubletInv = true;
            //     }
            // });
            if(self.cantAccessPage == ''){
                self.cantAccessPage = false;
            }
            
        },
        // vendorInvoiceId: function() {
        //     this.loadInvoicePreview('load');
        // }
    },
    mounted: function() {
        
        var self = this;
        var webloc = window.location.href;
        var decodeStr = "";
        
        if ( this.$route.query.data != '' && this.$route.query.data != undefined ) {
            
            decodeStr = atob(this.$route.query.data);
        }
        var userObj = JSON.parse(localStorage.getItem("user_obj"));
        if (userObj != null) {
            
            if (userObj.id > 0) {
                self.loggedInUser = userObj.id;
            }
        }
        
        //self.getPermissions();
        self.permissions.forEach(function (permissions) {
                
            if ( permissions.name == 'view_vendor_invoice' ) {
                self.cantAccessPage = true;
            } else if (permissions.name == 'can_verify_vendor_invoice') {
                self.canVerify = true;
            } else if (permissions.name == 'can_approve_vendor_invoice') {
                self.canApprove = true;
            }else if (permissions.name == 'view_general_ledger') {
                self.canViewGL = true; 
            } else if ( permissions.name == 'can_approve_sublet_invoice' ) {
                self.canApproveSubletInv = true;
            }
        });
        self.loadInvoicePreview('load');
        
    },      
    methods : {

        closeInvoicePreview(){
            
            var self = this;
            EventBus.$emit("close_vendor_invoice_preview", true);
        },
        loadInvoicePreview(value){
            var self = this;
            var fields = {};
            var error = false;
            self.dataFound = "";
            var fields = {
                flag:"load",
                id: self.vendorInvoiceId
            }
            if (value == "previous") {
                var fields = {
                    flag:"previous",
                    id: self.vendorInvoiceId,
                    vendor_id:self.vendor_id,
                    voucher_number:self.previous_voucher
                }
            }else if (value == "next") {
                var fields = {
                    flag:"next",
                    id: self.vendorInvoiceId,
                    vendor_id:self.vendor_id,
                    voucher_number:self.next_voucher
                }
            }
            
            if (!error) {
                self.loading = true;
                // if (value == "previous" || value == "next") {
                //     $("#previousBtn").prop("disabled", true);
                //     $("#nextBtn").prop("disabled", true);
                // }
                $.ajax({
                    url: process.env.ROOT_API + "/vendor-invoice/preview",
                    type: "POST",
                    headers: this.ajxHeaders,
                    data: fields,
                    dataType: "json",
                    success: function (data) {

                        self.loading = false;
                        if (value == "previous" || value == "next") {
                            $("#previousBtn").prop("disabled", false);
                            $("#nextBtn").prop("disabled", false);
                        }
                        console.log(data)
                        if (data.status == "success") {
                            self.glArr = [];
                            self.workOrderGLArr = [];
                            self.voucherNumber = data.content.voucher_number;
                            if ( data.content.found ) {
                                self.vendorInvoiceId = data.content.id;
                            }
                            self.dataFound = data.content.found;
                            self.fileFound = data.content.file_found;
                            if (data.content.file_found) {
                                self.selectedStatus = data.content.status;
                                // if (data.content.verified_by == self.loggedInUser){
                                //     self.isVerifiedBy = true;
                                // }else{
                                //     self.isVerifiedBy = false;
                                // }
                                self.extension = data.content.extension;
                                self.path = data.content.file_path;
                            }
                            if (data.content.status != "entered") {
                                self.glTitle = "General Ledger";
                            }
                            if (data.content.wo_data != undefined) {
                                if (data.content.wo_data != null) {
                                    if (data.content.wo_data.wo_status != undefined && data.content.wo_data.wo_status != null) {
                                        self.work_order_status = data.content.wo_data.wo_status;
                                        if (self.work_order_status.toLowerCase() == "approved") {
                                            self.woGlTitle = "Work Order GL";
                                        }
                                    }
                                }
                            }
                            if (data.content.work_order_gl != undefined) {
                                self.workOrderGLArr = data.content.work_order_gl;
                            }else{
                                self.workOrderGLArr = [];
                            }
                            if (data.content.status == "verified"){
                                if (data.content.gl != undefined && data.content.gl != null) {
                                    self.glArr = data.content.gl;
                                }
                            }
                            self.vendor_id = data.content.vendor_id;
                            self.invType = data.content.inv_type;
                            self.invoice_number = data.content.invoice_number;
                            self.vendor_po = data.content.vendor_po;
                            self.vendor = data.content.vendor;
                            self.status = data.content.bill_status;
                            self.amount = data.content.amount;
                            self.invoice_date = data.content.invoice_date;
                            self.due_date = data.content.due_date;
                            self.verified_by = data.content.verified_user;
                            self.approved_by = data.content.approved_user;
                            self.monthly_payable = data.content.monthly_payable;
                            self.previous_voucher = data.content.previous;
                            self.next_voucher = data.content.next;
                            if (data.content.status != "entered") {    
                                self.loadBillGL(data.content.id,data.content.voucher_number);
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (value == "previous" || value == "next") {
                            $("#previousBtn").prop("disabled", false);
                            $("#nextBtn").prop("disabled", false);
                        }
                        self.generateStatusCodeMessage(jqXHR,false,'vendor-invoice-preview');
                    }
                });
            }
        },
        confirmStatus(status){
            
            var self = this;
            if (self.selectedStatus == 'entered') {
                $("#verifyStatusBtnPreview").prop("disabled", true);
            }else if (self.selectedStatus == 'verified') {
                $("#approveStatusBtnPreview").prop("disabled", true);
                $("#disapproveStatusBtnPreview").prop("disabled", true);
            }else if (self.selectedStatus == 'disapproved') {
                $("#approveStatusBtnPreview").prop("disabled", true);
                $("#voidStatusBtnPreview").prop("disabled", true);
            }
            self.loading = true;
            var idArr = [];
            idArr.push(self.vendorInvoiceId);
            
            $.ajax({
                url: process.env.ROOT_API + "/bill/change-status",
                type: "POST",
                data: {arr:idArr,status:status},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    
                    if (self.selectedStatus == 'entered') {
                        $("#verifyStatusBtnPreview").prop("disabled", false);
                    }else if (self.selectedStatus == 'verified') {
                        $("#approveStatusBtnPreview").prop("disabled", false);
                        $("#disapproveStatusBtnPreview").prop("disabled", false);
                    }else if (self.selectedStatus == 'disapproved') {
                        $("#approveStatusBtnPreview").prop("disabled", false);
                        $("#voidStatusBtnPreview").prop("disabled", false);
                    }
                    if (data.status == "success") {
                        
                        self.$swal('','Vendor Invoice Status Updated Successfully.','success');
                        // self.loadInvoicePreview('load');
                    }
                    //Show Message if Vendor Invoice already attached to Line Item of Work Order and Work Order is closed
                    if (data.closed && data.closed.length > 0) {
                        var workOrderNo = "";
                        for(var i = 0;i< data.closed.length;i++) {
                            if (data.closed[i] != undefined) {
                                if (data.closed[i].wo_no != undefined) {
                                    if (data.closed[i].wo_no != null && data.closed[i].wo_no != "") {
                                        workOrderNo = data.closed[i].wo_no;
                                    }
                                }
                            }
                        }
                        if (workOrderNo != "") {
                            var woMessage = "Voucher already attached to Line Item of Work Order "+ workOrderNo;
                            self.$swal('',woMessage,'info');
                        }
                    }
                    self.loadInvoicePreview('load');
                },
                error: function (jqXHR, exception) {
                    
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-preview-change-status');
                }
            });
        },
        loadBillGL(billId,voucherNum) {
            var self = this;
            var fields = {
                name:"voucher",
                id:billId,
                doc_no:voucherNum
            };
            self.loadingGL = true;
            $.ajax({
                url:process.env.ROOT_API + "/module/gl",
                type:"POST",
                data:fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loadingGL = false;
                    if (data.status == "success"){
                        self.glArr = data.content;          
                    }
                },
                error: function (jqXHR, exception) {
                    self.loadingGL = false;
                    self.generateStatusCodeMessage(jqXHR,true,'bill-gl')
                }
            });
        }
    }
}
</script>
<style scoped>
.message-not-found {
	color: #002d6b;
	font-size: 20px;
	line-height: 28px;
	font-family: 'SanFranciscoDisplaybold';
	/* margin: 20px 20px 0; */
}
.border-none {
    border: none;
}
.wt-20 {
    width: 20%;
}
.wt-30 {
    width: 30%;
}
</style>


// WEBPACK FOOTER //
// src/components/accounting/VendorInvoicePreview.vue